"use client";

import {FCWithChildren} from "@/app/types/reactTypes";
import {useCampusContext} from "./CampusCookieContext";
import {createContext, useContext} from "react";

type DynamicMenuItemValue = {
	value?: string;
	isLoading: boolean;
};

type DynamicMenuItemContextType = {
	[key: string]: DynamicMenuItemValue;
};

const DynamicMenuItemContext = createContext<DynamicMenuItemContextType | null>(
	null
);

export const useDynamicMenuItemContext = () => {
	return useContext(DynamicMenuItemContext);
};

/**
 * Separate context in spite of it deriving from other contexts because we don't
 * necessarily know what values we'll need in dynamic hrefs and hopefully it's
 * easier to compose them here than to compile them in the respective menu components
 */

export const DynamicMenuItemProvider: FCWithChildren = ({children}) => {
	const {campus, isLoading: isFetchingCampus} = useCampusContext();

	return (
		<DynamicMenuItemContext.Provider
			value={{
				campus: {
					value: campus?.campusId,
					isLoading: isFetchingCampus,
				},
			}}
		>
			{children}
		</DynamicMenuItemContext.Provider>
	);
};
